var productFormSelector = 'form[action*="cart/add"].product-buy-form-pdp';

function OLVAXIN_GetProductForm(scope) {
    if (scope) {
        if (scope.matches && scope.matches(productFormSelector)) return scope;
        var scopedForm = scope.querySelector && scope.querySelector(productFormSelector);
        if (scopedForm) return scopedForm;
        var parentScope = scope.closest && scope.closest('.shop-product-section, .featured-product-section, [data-section-id]');
        if (parentScope) {
            scopedForm = parentScope.querySelector(productFormSelector);
            if (scopedForm) return scopedForm;
        }
        return null;
    }

    var forms = document.querySelectorAll(productFormSelector);
    if (forms.length === 1) return forms[0];
    // Compatibility path for legacy callers that have not supplied a component scope.
    return forms[0] || null;
}

function OLVAXIN_ProductFormExists(scope) {
    return OLVAXIN_GetProductForm(scope) !== null;
}

function OLVAXIN_ProductFormHasQuantityBreakItems(form) {
    return !!(form && form.querySelector('.quantity-break-variant-form'));
}

// Keep the native checkout and cart submit on the same, stable selling-plan field.
function OLVAXIN_SetProductFormSellingPlan(planId, scope) {
    var form = scope && scope.tagName === 'FORM' ? scope : OLVAXIN_GetProductForm(scope);
    if (!form) return null;
    var inputs = Array.from(form.querySelectorAll('input[name="selling_plan"]'));
    var input = inputs.shift();
    var changed = !input || inputs.length > 0;
    if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        form.appendChild(input);
    }
    inputs.forEach(function (duplicate) { duplicate.remove(); });
    // Additional gift items do not turn a standard main product into a multi-line bundle.
    var itemsMode = !form.querySelector('[name="id"]') && !!form.querySelector('input[name^="items["]');
    var value = itemsMode ? '' : String(planId || '');
    changed = changed || input.value !== value || input.disabled !== itemsMode;
    input.value = value;
    input.disabled = itemsMode;
    if (changed) input.dispatchEvent(new Event('change', { bubbles: true }));
    return input;
}

// Returns the variant ID from the product form (input[name="id"]), if it exists.
function OLVAXIN_GetProductFormVariantId(scope) {
    var form = OLVAXIN_GetProductForm(scope);
    if (!form) return null;
    var input = form.querySelector('input[name="id"]');
    return input && input.value ? input.value : null;
}

function OLVAXIN_SetProductFormVariantId(variantId, scope) {
    var form = OLVAXIN_GetProductForm(scope);
    if (!form) return false;
    var input = form.querySelector('input[name="id"]');
    if (!input && OLVAXIN_ProductFormHasQuantityBreakItems(form)) return true;
    if (input) {
        input.value = variantId !== undefined && variantId !== null && variantId !== '' ? String(variantId) : '';
        return true;
    }
    if (variantId === undefined || variantId === null || variantId === '') return true;
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'id';
    input.value = String(variantId);
    input.className = 'product-variant-id';
    form.appendChild(input);
    return true;
}

function OLVAXIN_ProductFormSwitchToItemsMode(items, options, scope) {
    var form = OLVAXIN_GetProductForm(scope);
    if (!form) return false;
    if (!items || !Array.isArray(items) || items.length === 0) return false;

    options = options || {};
    var containerClass = options.containerClass || 'product-form-items-container';
    var startIndex = options.startIndex !== undefined ? options.startIndex : 1;

    var existing = form.querySelector('.' + containerClass);
    if (existing) existing.remove();

    var singleItem = items.length === 1 ? items[0] : null;
    var hasLineItemProperties = singleItem && singleItem.properties && Object.keys(singleItem.properties).length > 0;

    // Shopify accelerated checkout recognizes a standard product form with one id.
    // Keep actual multi-line bundles in items[] mode so their cart data remains intact.
    if (singleItem && !hasLineItemProperties) {
        var singleIdInput = form.querySelector('input[name="id"]');
        if (!singleIdInput) {
            singleIdInput = document.createElement('input');
            singleIdInput.type = 'hidden';
            singleIdInput.name = 'id';
            singleIdInput.className = 'product-variant-id';
            form.appendChild(singleIdInput);
        }
        singleIdInput.value = String(singleItem.id);
        singleIdInput.removeAttribute('disabled');

        OLVAXIN_SetProductFormSellingPlan(singleItem.selling_plan, form);
        singleIdInput.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
    }

    var container = document.createElement('div');
    container.className = containerClass;

    items.forEach(function (item, i) {
        var index = startIndex + i;
        var idIn = document.createElement('input');
        idIn.type = 'hidden';
        idIn.name = 'items[' + index + '][id]';
        idIn.value = String(item.id);
        idIn.className = containerClass === 'quantity-break-variant-form' ? 'product-variant-quantity-break' : 'product-variant-id';
        container.appendChild(idIn);

        var qtyIn = document.createElement('input');
        qtyIn.type = 'hidden';
        qtyIn.name = 'items[' + index + '][quantity]';
        qtyIn.value = String(item.quantity != null ? item.quantity : 1);
        container.appendChild(qtyIn);

        if (item.selling_plan != null && item.selling_plan !== '') {
            var planIn = document.createElement('input');
            planIn.type = 'hidden';
            planIn.name = 'items[' + index + '][selling_plan]';
            planIn.value = String(item.selling_plan);
            container.appendChild(planIn);
        }

        if (item.properties && typeof item.properties === 'object') {
            Object.keys(item.properties).forEach(function (key) {
                var propIn = document.createElement('input');
                propIn.type = 'hidden';
                propIn.name = 'items[' + index + '][properties][' + key + ']';
                propIn.value = String(item.properties[key]);
                container.appendChild(propIn);
            });
        }
    });

    var mainIdInput = form.querySelector('input[name="id"]');
    if (mainIdInput) mainIdInput.remove();

    form.appendChild(container);
    OLVAXIN_SetProductFormSellingPlan('', form);
    return true;
}

function OLVAXIN_ProductFormSwitchToSingleIdMode(variantId, itemsContainerSelector, scope) {
    var form = OLVAXIN_GetProductForm(scope);
    if (!form) return false;

    if (itemsContainerSelector) {
        var container = form.querySelector(itemsContainerSelector);
        if (itemsContainerSelector === '.quantity-break-variant-form' && container) return true;
        if (container && (variantId === undefined || variantId === null || variantId === '')) {
            var firstIdInput = container.querySelector('input[name^="items["][name*="][id]"]');
            if (firstIdInput && firstIdInput.value) variantId = firstIdInput.value;
        }
        if (container) container.remove();
    }

    var input = form.querySelector('input[name="id"]');
    if (input) {
        if (variantId !== undefined && variantId !== null && variantId !== '') input.value = String(variantId);
        OLVAXIN_SetProductFormSellingPlan(form.querySelector('input[name="selling_plan"]')?.value, form);
        return true;
    }
    if (variantId === undefined || variantId === null || variantId === '') return true;

    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'id';
    input.value = String(variantId);
    input.className = 'product-variant-id';
    form.appendChild(input);
    OLVAXIN_SetProductFormSellingPlan(form.querySelector('input[name="selling_plan"]')?.value, form);
    return true;
}
